import styled from 'styled-components';
import { media } from 'helpers/breakpoints';

const Title = styled.h2`
  ${({ theme }) => theme.fontSize.M16};
  color: ${({ theme }) => theme.colors.GREY_DARKER};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  margin: ${({ theme }) => `${theme.spacing.M16} 0 ${theme.spacing.S8} 0`};

  ${media.large} {
    ${({ theme }) => theme.fontSize.L18};
    margin: ${({ theme }) => `${theme.spacing.M24} 0 ${theme.spacing.S8} 0`};
  }
`;

const FeatureGroup = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.S8};
`;

const CategoryTitle = styled.div`
  ${({ theme }) => theme.fontSize.M14};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
`;

export { Title, FeatureGroup, CategoryTitle };
